import React from "react";

import { Dialog, DialogContent, Slide, Typography,IconButton } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { Close } from "@mui/icons-material"; 

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DataPreviewModal = ({
  open,
  setOpen,
  data,
}: {
  open: boolean;
  setOpen: any;
  data: string;
}) => {
  const handleClose = () => {
    setOpen();
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={"md"}
    >
             <IconButton
        aria-label="close"
        onClick={handleClose}
        size="small"
        sx={{
          position: 'absolute',
          right: 2,
          top: 2,
      
        }}
      >
        <Close sx={{color : "gray"}}  fontSize="small"/>
      </IconButton>
      <DialogContent sx={{ p: 4 }}>
        <Typography>
          <pre> {data} </pre>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default DataPreviewModal;
